import { posthog } from 'posthog-js';

export function appendPostHogParams(url) {
  if (typeof window === 'undefined') return url;
  try {
    const distinctId = posthog.get_distinct_id();
    const sessionId = posthog.get_session_id();
    if (!distinctId || !sessionId) return url;
    return `${url}#distinct_id=${encodeURIComponent(distinctId)}&session_id=${encodeURIComponent(sessionId)}`;
  } catch {
    return url;
  }
}
